import { render, staticRenderFns } from "./passwordRedEnvelopeDetail.vue?vue&type=template&id=36463ca6&scoped=true&"
import script from "./passwordRedEnvelopeDetail.vue?vue&type=script&lang=js&"
export * from "./passwordRedEnvelopeDetail.vue?vue&type=script&lang=js&"
import style0 from "./passwordRedEnvelopeDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./passwordRedEnvelopeDetail.vue?vue&type=style&index=1&id=36463ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36463ca6",
  null
  
)

component.options.__file = "passwordRedEnvelopeDetail.vue"
export default component.exports